import React from 'react';
import styles from './TagsList.module.scss';

export default function TagsList({
  isFilter,
  isEdit,
  label,
  options = [],
  selected = [],
  isUnique = false,
  isBoolean = false,
  handleChange,
}) {
  function handleChangeList(value) {
    if (!handleChange) return null;
    if (isUnique) {
      return handleChange(value);
    }
    if (selected.find((s) => s === value)) {
      return handleChange(selected.filter((s) => s !== value));
    }
    return handleChange([...selected, value]);
  }

  function isSelected(val) {
    return selected?.some((s) => s === val);
  }

  return (
    <div
      className={`${styles.container} ${isBoolean ? styles.boolean : ''} ${
        !isEdit ? styles['not-edit'] : ''
      } ${isFilter ? styles['is-filter'] : ''}`}
    >
      {label && <label>{label}</label>}
      <div className={styles.list}>
        {isEdit
          ? options?.map((o) => {
            const isActive = isSelected(o.value);
            return (
              <button
                type="button"
                onClick={() => handleChangeList(o?.value)}
                className={isActive ? styles.selected : ''}
                key={o.value}
              >
                {o.label}
              </button>
            );
          })
          : options
            ?.filter((o) => isSelected(o?.value))
            .map((o) => {
              const isActive = isSelected(o.value);
              const isTrue = o.label === 'Oui';
              const className = isActive && isTrue ? styles.true : '';
              return (
                <button type="button" key={o.value} className={className}>
                  {o.label}
                </button>
              );
            })}
      </div>
    </div>
  );
}
